// ── ingredientMatch.js — 식재료 이름 정규화 매칭 ────────────────────
// 단가표 ↔ 레시피 식재료 이름을 비교할 때 공백·대소문자 차이를 무시.
// "볶은 당근" === "볶은당근" === "볶은  당근" === "볶은 당근 " (모두 같은 것으로 취급)
//
// 사용 지점:
//   - RecipeEditor : 매칭 상태 표시
//   - RecipeView   : 원가 계산
//   - App.js       : 반제품 자동 가격 동기화
//   - utils/menuProfitability, recipeUsage : 메뉴 이익률·재료 사용량
//   - PriceManager : 이름 변경 시 ingredients 일괄 갱신
//
// 주의: 정규화는 *비교 전용*. 저장된 name 값 자체는 사용자가 입력한 형태를 유지.

// ── 정규화: 모든 공백 제거 + 소문자
export function normalizeIngredientName(s) {
  return String(s ?? '').replace(/\s+/g, '').toLowerCase();
}

// ── 두 이름이 같은 식재료를 가리키는지
export function sameIngredientName(a, b) {
  const na = normalizeIngredientName(a);
  const nb = normalizeIngredientName(b);
  if (!na || !nb) return false;
  return na === nb;
}

// ── 단가표에서 이름으로 항목 찾기 (정규화 매칭)
export function findPriceByName(prices, name) {
  if (!Array.isArray(prices) || !name) return undefined;
  const target = normalizeIngredientName(name);
  if (!target) return undefined;
  return prices.find(p => normalizeIngredientName(p?.name) === target);
}

// ── 단가표에서 이름으로 인덱스 찾기 (정규화 매칭)
export function findPriceIndexByName(prices, name) {
  if (!Array.isArray(prices) || !name) return -1;
  const target = normalizeIngredientName(name);
  if (!target) return -1;
  return prices.findIndex(p => normalizeIngredientName(p?.name) === target);
}
